import { render, staticRenderFns } from "./review-layout.vue?vue&type=template&id=4d58c9ec&"
import script from "./review-layout.vue?vue&type=script&lang=js&"
export * from "./review-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports